import { Select } from "antd";
import React from "react";
import { useSetRecoilState } from "recoil";
import { searchCmpBox } from "../../recoilatoms/searchCmp";

const SearchSelectBox = () => {
  const setSearchCpm = useSetRecoilState(searchCmpBox);
  const handleCmp = (e) => {
    setSearchCpm(e.value);
  };

  return (
    <>
      <Select
        labelInValue
        defaultValue={{ value: "제목", label: "제목" }}
        style={{ width: 120, marginRight: 10 }}
        optionFilterProp="children"
        onChange={handleCmp}
        options={[
          {
            value: "제목",
            label: "제목",
          },
          {
            value: "작성자",
            label: "작성자",
          },
          {
            value: "조치담당자",
            label: "담당자",
          },
        ]}
      />
      {/* <select onChange={handleCmp}>
        {searchSelectCmp.map((cmp, idx) => (
          <option key={idx} value={cmp.key}>
            {cmp.name}
          </option>
        ))}
      </select> */}
    </>
  );
};

export default SearchSelectBox;
